import range from "lodash/range";
import { type FunctionComponent } from "react";

import Heading from "./img-heading.svg";
import Title from "./img-title.svg";
import { Column, Columns, Content, StyledInteractiveItem, StyledItem } from "./styles";

type Props = {
  className?: string;
};

export const PlusArchivePlaceholder: FunctionComponent<Props> = () => (
  <Content>
    <Title />

    <Columns>
      {range(3).map(item => (
        <Column key={item}>
          <Heading />

          <StyledItem />
        </Column>
      ))}
      <Column>
        <Heading />

        <StyledInteractiveItem />
      </Column>
    </Columns>
  </Content>
);
PlusArchivePlaceholder.displayName = "PlusArchivePlaceholder";
